"use client";

import { c as _c } from "react/compiler-runtime";
import { INotificationDropReplied } from "@/types/feed.types";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import Drop, { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiDrop } from "@/generated/models/ApiDrop";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import NotificationHeader from "../subcomponents/NotificationHeader";
import { useWaveNavigation } from "../utils/navigationUtils";
export default function NotificationDropReplied(t0) {
  const $ = _c(32);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const {
    navigateToWave
  } = useWaveNavigation();
  const baseWave = notification.related_drops[1].wave as any;
  const isDirectMessage = baseWave?.chat?.scope?.group?.is_direct_message ?? false;
  let t1;
  if ($[0] !== isDirectMessage || $[1] !== navigateToWave || $[2] !== notification.related_drops[1].wave.id) {
    t1 = serialNo => {
      navigateToWave(notification.related_drops[1].wave.id, serialNo, isDirectMessage);
    };
    $[0] = isDirectMessage;
    $[1] = navigateToWave;
    $[2] = notification.related_drops[1].wave.id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onReplyClick = t1;
  let t2;
  if ($[4] !== isDirectMessage || $[5] !== navigateToWave) {
    t2 = quote => {
      const quoteWave = quote.wave as any;
      const quoteIsDm = quoteWave?.chat?.scope?.group?.is_direct_message ?? isDirectMessage;
      navigateToWave(quote.wave.id, quote.serial_no, quoteIsDm);
    };
    $[4] = isDirectMessage;
    $[5] = navigateToWave;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onQuoteClick = t2;
  const t3 = notification.related_drops[1].author;
  let t4;
  if ($[7] !== notification.related_drops[1].author) {
    t4 = <NotificationsFollowBtn profile={notification.related_drops[1].author} size={UserFollowBtnSize.SMALL} />;
    $[7] = notification.related_drops[1].author;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">replied</span>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-font-bold tw-mr-1 tw-text-iron-400">•</span>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== notification.created_at) {
    t7 = getTimeAgoShort(notification.created_at);
    $[11] = notification.created_at;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t6}{t7}</span>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== notification.related_drops[1].author || $[16] !== t4 || $[17] !== t8) {
    t9 = <NotificationHeader author={t3} actions={t4}>{t5}{t8}</NotificationHeader>;
    $[15] = notification.related_drops[1].author;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== notification.related_drops[1]) {
    t10 = {
      type: DropSize.FULL,
      ...notification.related_drops[1],
      stableKey: "",
      stableHash: ""
    };
    $[19] = notification.related_drops[1];
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== activeDrop || $[22] !== onDropContentClick || $[23] !== onQuote || $[24] !== onQuoteClick || $[25] !== onReply || $[26] !== onReplyClick || $[27] !== t10) {
    t11 = <Drop drop={t10} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} />;
    $[21] = activeDrop;
    $[22] = onDropContentClick;
    $[23] = onQuote;
    $[24] = onQuoteClick;
    $[25] = onReply;
    $[26] = onReplyClick;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t9) {
    t12 = <div className="tw-w-full tw-flex tw-flex-col tw-space-y-2">{t9}{t11}</div>;
    $[29] = t11;
    $[30] = t9;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
}